import { twMerge } from 'tailwind-merge';
import type { EnumParameter as EnumParameterType } from '@witmetrics/utils';
import { CheckBoxIcon, UncheckBoxIcon } from '@/icons';
import ParameterCard from '../ParameterCard';
import { BOOLEAN_ENUM_VALUES } from '../constants';
import { buildImagePath, findSelectedOption } from '../utils';
import { classes } from './utils';

export type BooleanEnumParameterProps = {
  parameter: EnumParameterType;
  value: string | null;
  onChange: (value: string) => void;
};

export default function BooleanEnumParameter({
  parameter,
  value,
  onChange,
}: BooleanEnumParameterProps) {
  const isEnabled = value === BOOLEAN_ENUM_VALUES.ENABLED;
  const selectedOption = findSelectedOption(parameter, value);
  const img = selectedOption?.imgSrc || parameter.imgSrc;

  const handleToggle = () => {
    onChange(
      isEnabled ? BOOLEAN_ENUM_VALUES.DISABLED : BOOLEAN_ENUM_VALUES.ENABLED
    );
  };

  const checkbox = isEnabled ? (
    <CheckBoxIcon
      className={twMerge(classes.checkbox, classes.checkboxChecked)}
    />
  ) : (
    <UncheckBoxIcon
      className={twMerge(classes.checkbox, classes.checkboxUnchecked)}
    />
  );

  return (
    <ParameterCard
      interactive
      selected={isEnabled}
      description={parameter.description}
      headerStartAdornment={checkbox}
      label={parameter.label}
      onClick={handleToggle}>
      <div className={classes.body}>
        {img && (
          <img
            className={classes.image}
            src={buildImagePath(img)}
            alt={parameter.label}
          />
        )}
        <span className={classes.label}>{selectedOption?.label ?? ''}</span>
      </div>
    </ParameterCard>
  );
}
